import type { ReadonlyURLSearchParams } from 'next/navigation';

/**
 * `?promo` brings back Stripe's promotion-code field, which is otherwise hidden:
 * an empty "Add code" box in front of every buyer is an invitation to leave and
 * hunt for a discount that mostly does not exist. Presence is the whole signal, so
 * a seller running a campaign shares their normal link with one param added.
 */
export const PROMO_PARAM = 'promo';

export const hasPromoParam = (searchParams: URLSearchParams | ReadonlyURLSearchParams): boolean =>
  searchParams.get(PROMO_PARAM) !== null;
